import BriefingPage from "../pages/BriefingPage";
export default BriefingPage;
